import React, { Component } from "react";

class Experiencia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [
        {
          key: 1,
          title: "Jefe de Action Kids",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 2,
          title: "Jefe de Alberca",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 3,
          title: "Jefe de Clases Dirigidas",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 4,
          title: "Jefe de Acondicionamiento Físico",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 5,
          title: "Coordinador de Ventas",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 6,
          title: "Coordinador de Atención a Clientes",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 7,
          title: "Gerente General",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        }
      ]
    };
  }

  click(index, item, value, indexValue) {
    for (var i in this.state.options) {
      for (var j in this.state.options[i].options) {
        this.state.options[index].options[j].active = false;
      }
    }
    this.state.options[index].options[indexValue].active = true;
    this.setState(this.state, () =>
      this.props.callbackValue(item.title, value.key, index)
    );
  }

  render() {
    const experiencia = this.state.options.map((items, $index) => {
      if (items.key !== 3) {
        return (
          <tr key={items.key}>
            <td>{items.title} </td>
            {items.options.map((cell, $indexCell) => (
              <td key={cell.key}>
                <i
                  className={`survey-question-btn ${cell.active ? "active" : ""}`}
                  onClick={() => this.click($index, items, cell, $indexCell)}
                >
                  <i className="survey-question-btn-center" />
                </i>
              </td>
            ))}
          </tr>
        )
      }
    });
    return (
      <div className="survey-question">
        <p className="survey-question-text">
          ¿De acuerdo a estas experiencias calificaría el equipo de la siguiente
          manera? <span>*</span>
        </p>
        <p className="survey-question-subtext">
          1= ME GUSTA POCO / 5= ME GUSTA MUCHO / NA= NO APLICA, NO LO USO
        </p>
        <div className="survey-table-options">
          <table>
            <tbody>
              <tr className="survey-table-options-header">
                <td />
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
                <td>NA</td>
              </tr>
              {experiencia}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Experiencia;



// WEBPACK FOOTER //
// ./src/components/Experiencia.js